export * from "./exclusive-card.component";
